import React, { useEffect, useState } from "react";

/**
 * Componente que contiene la información y funcionalidad asignada a un quirófano
 * @param {Object} param0 Recibe los objetos relacionados con el tipo resource y permiten su interacción con el usuario
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const ResourceElement = ({resource,resourcesSelected,setResourcesSelected,mostrarOcultarResources}) => {
    
    //Estado que indica si el quirófano corresponde con el seleccionado por el usuario
    const [isSelected,setIsSelected] = useState(false)

    useEffect(()=>{
        if(resource.Resource_Name === resourcesSelected){//Se verifica si el quirófano corresponde con el seleccionado por el usuario
            setIsSelected(true)
        }
        else{
            setIsSelected(false)
        }
    },[resource,resourcesSelected])

    /**
     * Función que atrapa la selección de un quirófano
     * @param {String} Resource_Name Recibe el identificador del quirófano
     * @returns Devuelve el estado del objeto
     */
    const seleccionarResource = (Resource_Name) => (event) => {
        event.preventDefault()
        //Se asigna el quirófano seleccionado y se oculta la lista de resources
        setResourcesSelected(Resource_Name)
        mostrarOcultarResources()
    }

    
    return(
        <>
            {
                isSelected
                    ?
                        <div className="contenedor_item_selected" onClick={seleccionarResource(resource.Resource_Name)}>
                            <p>{resource.Resource_Name}</p>
                        </div>
                    :
                        <div className="reservar_contenedor_item" onClick={seleccionarResource(resource.Resource_Name)}>
                            <p>{resource.Resource_Name}</p>
                        </div>
            }
        </>
    )
}

export default ResourceElement;